<script setup lang="ts">
const storeIndex = useStoreIndex()
const kjdsPageConfig = storeIndex.getPageConfig()

console.log('#KJDS pages/[article]: kjdsPageConfig', kjdsPageConfig)

definePageMeta({
  layout: false,
  // app.config.tsでparams.articleが定義されいるか
  validate: (route) => {
    if (route.params.article) {
      const kjdsConfig = useAppConfig().kijidas
      const kjdsPageConfig: KjdsPageConfig = kjdsConfig.page[route.params.article as string]
      if (kjdsPageConfig) {
        return true
      }
    }
    console.warn('##KJDS pages/[article]: params.article not config', route.params.article)
    return false
  },
})
</script>

<template>
  <NuxtLayout
    v-bind:name="kjdsPageConfig.list.layout"
  >
    <component
      v-bind:is="kjdsPageConfig.list.component"
      v-bind:kjds-page-config="kjdsPageConfig"
    />
  </NuxtLayout>
</template>
